import React from 'react';
import { Avatar, Box, keyframes, styled } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const cycle = keyframes`
  0%, 66%, 100% { opacity: 0.25; }
  33%            { opacity: 1;    }
`;

const Dot = styled('div')({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: '#0857C3',
  animation: `${cycle} 1.2s infinite ease-in-out`,
  '&:nth-of-type(1)': { animationDelay: '0s'    },
  '&:nth-of-type(2)': { animationDelay: '0.4s'  },
  '&:nth-of-type(3)': { animationDelay: '0.8s'  },
});

interface Props {
  avatarSrc?: string;
  avatarName?: string;
}

const TypingIndicator: React.FC<Props> = ({ avatarSrc, avatarName }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: 1.5, pb: 1 }}>
    <Avatar
      src={avatarSrc}
      alt={avatarName}
      sx={{ width: 32, height: 32, bgcolor: '#7C3AED', color: '#fff', flexShrink: 0 }}
    >
      {!avatarSrc && <SmartToyIcon sx={{ fontSize: 18 }} />}
    </Avatar>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <Dot />
      <Dot />
      <Dot />
    </Box>
  </Box>
);

export default TypingIndicator;
